var _rect, _rect2, _rect3, _rect4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#241A0F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#241A0F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#241A0F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#241A0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.99963C4 5.17145 4 3.75736 4.87868 2.87868C5.75736 2 7.17172 2 10.0004 2C10.7115 2 11.3975 2 12 2C12.6025 2 13.2885 2 13.9996 2C16.8283 2 18.2426 2 19.1213 2.87868C20 3.75736 20 5.17145 20 7.99963C20 9.35112 20 10.7535 20 12C20 13.2465 20 14.6489 20 16.0004C20 18.8285 20 20.2426 19.1213 21.1213C18.2426 22 16.8283 22 13.9996 22C13.2885 22 12.6025 22 12 22C11.3975 22 10.7115 22 10.0004 22C7.17172 22 5.75736 22 4.87868 21.1213C4 20.2426 4 18.8285 4 16.0004C4 14.6489 4 13.2465 4 12C4 10.7535 4 9.35112 4 7.99963Z",
    stroke: "#241A0F",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.c973d5e64bf754ba6160c09a32b973b0.svg";
export { ForwardRef as ReactComponent };